// store/index.js
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    screenWidth: 0,
    userInfo: null,
  },
  mutations: {
    setScreenWidth(state, screenWidth) {
      state.screenWidth = screenWidth;
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
      // 同步到localStorage
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
    },

    clearAuth(state) {
      state.userInfo = null;
      // 清除localStorage
      localStorage.removeItem("userInfo");
    },
  },
  actions: {
    login({ commit }, { userInfo }) {
      commit("setUserInfo", userInfo);
    },
    logout({ commit }) {
      commit("clearAuth");
    },
    initAuth({ commit }) {
      // 从localStorage加载登录信息
      const userInfo = localStorage.getItem("userInfo");
      if (userInfo) {
        commit("setUserInfo", JSON.parse(userInfo));
      }
    },
  },
  getters: {
    userInfo: (state) => state.userInfo,
  },
});
